import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Lookup from '@/api/lookup/api-lookup';
import { firstListItem } from '@/constants/defaultValues';
import { getLabel } from '@/helpers/Utils';

export const fetchReligion = createAsyncThunk(
  'religion/fetchReligion',
  async (params, thunkAPI) => {
    try {
      const response = await Lookup.GetReligion();
      const mappedData =
        response?.data?.data?.map((item) => ({
          id: item.id,
          nameEn: item.nameEn,
          nameAr: item.nameAr,
          code: item.code,
          label: item.name,
          value: item.id,
        })) ?? [];
      return [firstListItem, ...mappedData];
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const initialState = {
  religionList: [],
  loading: false,
  error: '',
};

const religionSlice = createSlice({
  name: 'religion',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchReligion.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchReligion.fulfilled, (state, action) => {
        state.loading = false;
        state.religionList = action.payload;
        state.error = '';
      })
      .addCase(fetchReligion.rejected, (state, action) => {
        state.loading = false;
        state.religionList = [];
        state.error = action.payload ?? 'An error occurred';
      });
  },
});

export default religionSlice.reducer;
